/**
 * 官网留言提交。
 *
 * 后端是 dddi_core 的 POST /api/v1/contact/cyberate-investments，它负责
 * 落库（经回源写 YesAPI 的 contact_form_message）并给管理员发提醒邮件。
 *
 * 换掉了「前端直连 YesAPI 的 App/Table/Create」。那条路有两个问题：
 *   1. 要求把 app_key 打进 JS bundle，等于把这张表的写权限公开 ——
 *      这个文件里原本还硬编码了一个 key 作为兜底，随源码一起进了仓库。
 *   2. 只写库，没有任何提醒，新留言全靠人去后台翻。
 *
 * 现在前端不持有任何凭证。契约不变：返回 { ok, message?, data? }。
 */

const ENDPOINT =
    process.env.REACT_APP_CONTACT_API ||
    process.env.NEXT_PUBLIC_CONTACT_API ||
    'https://api.dddi.com.au/api/v1/contact/cyberate-investments';

const str = (v) => (v === undefined || v === null ? '' : String(v));

/**
 * 调用方传的还是表的列名（fullname / message_subject / ext_info），
 * 这里翻译成端点的入参名，省得十几处调用点跟着改。
 */
function toRequestBody(data = {}) {
    let ext = data.ext_info || {};

    if (typeof ext === 'string') {
        try {
            ext = JSON.parse(ext);
        } catch {
            // 解析不了就原样带上，总比丢掉强
            ext = { ext_info: ext };
        }
    }

    const body = {
        fullname: str(data.fullname || data.name),
        email: str(data.email),
        message: str(data.message),
        page_info: str(data.page_info),
    };

    const phone = str(data.phone);
    const subject = str(data.message_subject || data.subject);

    if (phone) body.phone = phone;
    if (subject) body.subject = subject;
    if (Object.keys(ext).length > 0) body.ext = ext;

    // message_status 不再由前端决定：服务端统一把新留言标成未读

    return body;
}

export async function createContactFormMessage(data) {
    try {
        const response = await fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(toRequestBody(data)),
        });

        const result = await response.json().catch(() => ({}));

        // 后端只要落库与发信有一条成功就返回 201。两条都失败才是 502 ——
        // 那种情况下留言是真的没留下，必须让用户看到失败。
        if (response.status !== 201 || result?.data?.received !== true) {
            return {
                ok: false,
                message: result?.error?.message || `提交失败（HTTP ${response.status}）`,
            };
        }

        return { ok: true, data: result.data };
    } catch (error) {
        return {
            ok: false,
            message: error instanceof Error ? error.message : '网络错误',
        };
    }
}
